import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Divider,
  Flex,
  HStack,
  Image,
  Text,
  useToast,
  VStack
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Pagination from "react-paginate";
import { useNavigate, useParams } from "react-router-dom";
import DashboardHeader from "../../../components/common/DashboardHeader";
import Loading from "../../../components/common/Loading";
import TraineeSidenav from "../../../components/trainee/courses/Sidenav";
import notepad from "../../../img/notepad2.svg";
import rarrow from "../../../img/rarrow.svg";
import {
  QuestionHeaderRes
} from "../../../models/assignments/theory-assignment.model";
import coursesService from "../../../services/courses.service";
import trainerAssignmentService from "../../../services/trainer/trainer-assignment.service";
import { getFullDate } from "../../../utils/classOfDegree";

const Assignments = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [courseAssignments, setCourseAssignments] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  const params = useParams();
  console.log(params, "check params");
  const course_id: any = params.course_id;
  const courseName: null | string = localStorage.getItem("courseName");

  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const currentItems = courseAssignments.slice(
    currentPage * perPage,
    (currentPage + 1) * perPage
  );

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected);
  };

  useEffect(() => {
    if (course_id) {
      coursesService
        .getAvailableCourses()
        .then((response) => {
          console.log(response, "check for this course")
          const available_course = response.find(
            (each) => each.course.uuid == course_id 
          );
          if (available_course) {
            trainerAssignmentService
              .getCourseAssignmentTopics(
                course_id,
                available_course.session_id.toString(),
                available_course.term_id.toString()
              )
              .then((res) => {
                setCourseAssignments(res.data);
                setLoading(false);
              });
          }else{
            toast({
              title: "Course not available for this session",
              description: "You can't take assessment for this course",
              status: "error",
              duration: 5000,
              isClosable: true,
            });
            navigate(-1);
          }
        })
        .catch((err) => err);
    }
  }, [course_id]);

  const savequestionHeader = (assignment: any) => {
    sessionStorage.setItem("ques_head_info", JSON.stringify(assignment));
    navigate(`/trainee/course/${course_id}/assignments/quiz-answer`);
  };
  const savequestionHeaderTh = (assignment: any) => {
    sessionStorage.setItem("ques_head_info", JSON.stringify(assignment));
    navigate(`/trainee/course/${course_id}/assignments/theory-answer`);
  };

  const SingleAssignment = ({ each, hidden }: any) => {
    const [info, setInfo] = useState(false);
    const toggleInfo = () => {
      setInfo(!info);
    };

    return (
      <Box pb="25px" hidden={hidden}>
        <Flex
          cursor="pointer"
          onClick={() => {
            toggleInfo();
          }}
          justifyContent="space-between"
          border="1px solid"
          borderColor="lightgray"
          alignItems="center"
          pr="30px"
          py="25px"
          boxShadow="base"
        >
          <Box mr="10px" ml="25px">
            <Image src={notepad} />
          </Box>
          <Box mr="45px">
            <Text fontWeight="600" color="#616161" fontSize="20px">
              {each.title}
            </Text>
          </Box>
          <VStack>
            <Text fontSize="14px" fontWeight={"600"} color="#AEAEAE">
              {each.category}
            </Text>
            <Text fontSize="14px" color="#AEAEAE">
              Question Type: {each.type}
            </Text>
          </VStack>

          <VStack spacing={0}>
            <Text fontSize="13px" color="#AEAEAE">
              Due date
            </Text>
            <Text fontWeight="400" color="#616161" fontSize="14px">
              {getFullDate(each.end_date)}
            </Text>
          </VStack>
        </Flex>
        {info && (
          <Flex
            justifyContent="space-between"
            borderLeft="0.5px solid"
            borderRight="0.5px solid"
            borderBottom="0.5px solid"
            borderColor="lightgray"
            alignItems="center"
            mb="30px"
            pr="30px"
            py="25px"
            boxShadow="base"
          >
            <Box mr="45px" ml="25px">
              <Text fontWeight="500" color="#959595" fontSize="15px">
                Posted on {getFullDate(each.created_at)}
              </Text>
              <Text fontWeight="500" fontSize="15px" color="#959595">
                {each.description}
              </Text>
              {each.type == "Quiz" ? (
                <Text
                  fontWeight="500"
                  cursor={"pointer"}
                  fontSize="15px"
                  onClick={() => {
                    savequestionHeader(each);
                  }}
                  color="#EC3337"
                >
                  Start Quiz
                </Text>
              ) : (
                <Text
                  fontWeight="500"
                  cursor={"pointer"}
                  fontSize="15px"
                  onClick={() => {
                    savequestionHeaderTh(each);
                  }}
                  color="#EC3337"
                >
                  Answer Questions
                </Text>
              )}
            </Box>
            <Divider orientation="vertical" />
            <VStack spacing={0}>
              <Text fontSize="24px" fontWeight="500" color="#353535">
                {each.pass_mark}%
              </Text>
              <Text fontWeight="400" color="#616161" fontSize="14px">
                Pass Mark
              </Text>
            </VStack>
          </Flex>
        )}
      </Box>
    );
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box>
          <DashboardHeader />
          <Box bg="#F9F8F8" minHeight="90vh">
            <Flex width="90%" mx="auto" pt="80px">
              <TraineeSidenav />
              <VStack width={{ lg: "80%", md: "80%", sm: "95%", base: "95%" }}>
                <HStack width={"100%"} height={"2rem"}>
                  <Text as="span" fontSize={"20px"}>
                    {courseName && courseName.replaceAll(/"/g, "")}
                  </Text>
                  <Image src={rarrow} />
                  <Text as="span" fontSize={"20px"} color={"#616161"}>
                    Assessments
                  </Text>
                </HStack>
                <Box
                  width="100%"
                  mb="1rem"
                  mx="auto"
                  pb="40px"
                  pl="75px"
                  pt="50px"
                  bg="white"
                  pr="70px"
                >
                  <Flex justifyContent="space-between" alignItems="center">
                    <Text
                      color="#1E1E1E"
                      fontSize="28px"
                      pb="30px"
                      fontWeight="600"
                    >
                      Assessments{" "}
                    </Text>
                  </Flex>

                  {courseAssignments && courseAssignments.length > 0 ? (
                    currentItems.map(
                      (each: QuestionHeaderRes, index: number) => {
                        return (
                          <SingleAssignment
                            each={each.question_header}
                            hidden={each.question_header_taken}
                            key={index}
                          />
                        );
                      }
                    )
                  ) : (
                    <Flex justifyContent={"center"}>NO ASSESSMENTS</Flex>
                  )}

                  {currentItems.length > 0 && !loading ? (
                    <Box pb="0rem">
                      <Pagination
                        breakLabel="..."
                        nextLabel={<ArrowRightIcon style={{ fontSize: 18 }} />}
                        onPageChange={handlePageChange}
                        pageRangeDisplayed={5}
                        pageCount={Math.ceil(
                          courseAssignments.length / perPage
                        )}
                        previousLabel={
                          <ArrowLeftIcon style={{ fontSize: 18 }} />
                        }
                        containerClassName="pagination"
                        pageLinkClassName="page-num"
                        previousLinkClassName="page-num"
                        nextLinkClassName="page-num"
                        activeLinkClassName="active"
                        // renderOnZeroPageCount={null}
                      />
                    </Box>
                  ) : (
                    ""
                  )}
                </Box>
              </VStack>
            </Flex>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Assignments;
